import { ViewModel,View } from "binder"
import  { BarcodeReaderView } from "./barcodeReader-view"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";

export class BarcodeReaderComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'BarcodeReader';
        this.canAcceptContent = false;

        this.addProperty("ReadCode","data-b-comp-readcode",new StringPropertyType(this),null,false);
    }

    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new BarcodeReaderViewModel(parent);
        return result;
    }
        
}

export class BarcodeReaderViewModel extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new BarcodeReaderView();
    }
    public getTypeId(): string {
        return "VM-8843B2C1-52F0-4535-960D-0DD26AB66C41"
    }

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitBarcodeReader(this,parameter);
    }

    public set ReadCode(v: string) { this._ReadCode = v; } public get ReadCode(): string { return this._ReadCode;} private _ReadCode: string;
}
